module.exports = __webpack_public_path__ + "img/maj_cat_header.926f3d62.svg";